import { Encoder, Decoder } from '@msgpack/msgpack';

import { type Message } from '@canvas/protocol-types';

import {
  decodeMessageKeys,
  encodeMessageKeys,
  type EncodedMessage,
} from '../message-key.ts';

const encoder = new Encoder();
const decoder = new Decoder();

export function encodeMessageV2(message: Message): Uint8Array<ArrayBuffer> {
  const keyEncodedMessage = encodeMessageKeys(message);

  return encoder.encode(keyEncodedMessage);
}

export function decodeMessageV2(encodedMessage: Uint8Array<ArrayBuffer>): Message {
  const keyEncodedMessage = decoder.decode(encodedMessage) as EncodedMessage;
  return decodeMessageKeys(keyEncodedMessage);
}
